export default __webpack_public_path__ + "static/exp4-d1c84492471f971d477afcb1b6fd0ffa.webp";